export const REVIEWS_LIST = [
  {
    id: 1,
    name: "Oliver",
    date: "20 Mar 2023",
    text: "I would like to express my gratitude to this company for their excellent work! The kitchen has been done with great attention to detail and I feel like I got the highest quality furniture. I was also very pleased with the service the company provides. I recommend this company to everyone. Thank you for your excellent work!",
  },
  {
    id: 2,
    name: "Maria",
    date: "17 Apr 2023",
    text: "I would happily recommend this company to anyone looking for quality furniture. The furniture looks incredibly cozy and comfortable, and it is made of high quality materials. I was pleasantly surprised by how quickly my order was completed.",
  },
  {
    id: 3,
    name: "Adam",
    date: "03 Mar 2023",
    text: "The furniture looks very nice and modern, and most importantly, it is functional and comfortable to use. I received excellent service from start to finish - the company's employees were professional and attentive to all my needs.",
  },
  {
    id: 4,
    name: "Victoria",
    date: "26 Jan 2023",
    text: "I ordered a living room set from this company. The furniture looks very nice and stylish. Every detail of the furniture has been thought out to the smallest detail, and I feel that I received the furniture of the highest quality. Employees of the companies are always ready to help with all questions.",
  },
];
